import { render } from "./new.vue?vue&type=template&id=f71e6c00"
import script from "./new.vue?vue&type=script&lang=ts"
export * from "./new.vue?vue&type=script&lang=ts"
script.render = render

export default script